import { createStore, applyMiddleware, compose } from "redux";
import thunkMiddleware from "redux-thunk";

const middlewares = [thunkMiddleware];

export default (ReduxStore) =>
  createStore(
    ReduxStore,
    compose(
      applyMiddleware(...middlewares),
      typeof window.__REDUX_DEVTOOLS_EXTENSION__ === "undefined"
        ? (a) => a
        : window.__REDUX_DEVTOOLS_EXTENSION__ &&
            window.__REDUX_DEVTOOLS_EXTENSION__()
    )
  );
